module.exports = __webpack_public_path__ + "static/img/wave.3c0c4d0a.png";